module.exports = __webpack_public_path__ + "static/media/ron.116b4a35.png";